import { ConnectorSpec } from '@integration-app/sdk'
import classes from 'routes/Connectors/Connector/components/IntegrationsOnEvents/integrationsOnEvents.module.css'
import { Hgroup } from 'routes/components/Hgroup'
import { DOCS_LINK } from 'routes/constants'

const EVENTS = [
  'Data Record Created',
  'Data Record Updated',
  'Data Record Deleted',
]

export function IntegrationsOnEvents({
  connector,
}: {
  connector: ConnectorSpec
}) {
  return (
    <div className={classes.wrapper}>
      <Hgroup>
        <h2>Trigger integrations on {connector.name} events</h2>
        <p>
          React to events in the external app. Receive changes in data
          regardless of whether webhooks are supported or not.
        </p>
        <p>
          <a target='_blank' href={`${DOCS_LINK}/building/external-events`}>
            Read more about working with events
          </a>
        </p>
      </Hgroup>
      <div className={classes.events}>
        {EVENTS.map((event, i) => (
          <div className={classes.event} key={i}>
            <h4 className={classes.event_title}>{event}</h4>
          </div>
        ))}
      </div>
    </div>
  )
}
